import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { Card, CardBody, CardHeader } from '_metronic/_partials/controls';
import { DataTableLocal as DataTable } from '../../../components/common/DataTable';
import LoadingCard from 'app/components/common/LoadingCard/LoadingCard';
import swal from 'sweetalert2';
import { fetchMedicalRecordListByPatientID } from 'redux/medicalRecord/list';
import MedicalRecord from 'app/models/MedicalRecord';
import Appointment from '../../../models/Appointment';
import { TextField } from 'app/components/common/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Files from '../../../models/File';
import SignatureCanvas from 'react-signature-canvas';
import Select from 'react-select';
import { Description } from '@material-ui/icons';
import DoctorSignConsent from './DoctorSignConsent';

const docuType = [
  {
    label: "Operasi",
    value: "OPERASI"
  },
  {
    label: "Penitipan",
    value: "PENITIPAN"
  },
  {
    label: "Rawat Inap",
    value: "RAWAT INAP"
  },
]

/* const consentText = [
  {
    key: "OPERASI",
    text: "Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi Lorem Ipsum Operasi"
  },
  {
    key: "PENITIPAN",
    text: "Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan"
  },
  {
    key: "RAWAT INAP",
    text: "Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap"
  }
] */

const consentText = {
  "OPERASI": 'Dengan ini saya memberikan kuasa sepenuhnya dan langsung kepada team dokter hewan di "drh. Rajanti & Friends" untuk melaksanakan prosedur yang diperlukan untuk pengobatan/operasi yang dianggap perlu untuk hewan saya. \n\n \
              Saya mengerti sepenuhnya bahwa prosedur dan tindakan medis yang dilakukan dapat menimbulkan resiko dan tidak ada jaminan yang diberikan untuk hasil atau kesembuhannya. \n\n \
              Saya menyadari sepenuhnya bahwa hewan saya bisa tertular penyakit atau kutu dan dapat terjadi shock mendadak yang dapat mengakibatkan kematian. Saya juga mengerti bisa saja terjadi resiko hewan saya hilang atau lepas karena ketidaksengajaan. \n\n \
              Saya tidak akan menuntut baik secara materil maupun secara moril bila terjadi sesuatu yang tidak kita inginkan tersebut. \n\n \
              Saya setuju untuk membayar penuh jasa yang telah diberikan, termasuk yang dianggap perlu untuk pengobatan ataupun komplikasi yang komplikasi yang tidak diperkirakan sebelumnya. \n\n \
              Saya setuju untuk membayar lunas sebelum hewan saya dibawa/diantar pulang. \n\n \
              Saya memberikan kekuasaan penuh kepada pihak "drh. Rajanti & Friends" untuk mengatur status kepemilikan baru atau mengurus hewan saya bila saya tidak mengambil hewan yang saya titipkan dalam waktu 3 (tiga) hari dari tanggal pengambilan yang telah disepakati bersama, dengan atau tanpa pemberitahuan terlebih dahulu. \n\n \
              Saya paham bahwa klinik tidak mengijinkan penitipan barang seperti kandang, pet cargo, selimut, kalung dan leash, tempat makan dan minum, mainan, dsb selama hewan dititipkan di klinik. Saya tidak akan meminta pertanggungjawaban apabila terjadi kehilangan barang-barang tersebut.',
  "PENITIPAN": "Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan Lorem Ipsum Penitipan",
  "RAWAT INAP": "Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap Lorem Ipsum Rawat Inap"
}

const ConsentList = ({patients}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { role } = useSelector(state => state.auth);
  const { ID } = useSelector(state => state.auth);

  const [consentList, setConsentList] = useState([]);
  const [showSignature, setShowSignature] = useState(false);
  const [signeeName, setSigneeName] = useState('');
  const [signeeRole, setSigneeRole] = useState('');
  const [documentType, setDocumentType] = useState({label: "Operasi", value: "OPERASI"});
  const [patientList, setPatientList] = useState([])
  const [selectedPatient, setSelectedPatient] = useState(null)
  const [description, setDescription] = useState('')

  const [selectedData, setSelectedData] = useState(null)
  const [showSigg, setShowSigg] = useState(false)
  let sigCanvas = useRef({});
  let sigCanvasDoctor = useRef({});

  const initialize = async () => {

    let AppointmentModel = new Appointment();

    console.log("cek isi", patients)

    try {
      let tempPatients = []
      patients.forEach(p => tempPatients.push({label: p.patient_name, value: p.id}))

      setPatientList(tempPatients)

      let consents = await AppointmentModel.getAllAppointmentUserConsentByAppointmentUserId(id);
      console.log('consents', consents);

      setConsentList(consents);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  const handleCloseSignature = () => {
    setShowSignature(false);
  };

  const dataURLtoBlob = dataUrl => {
    var arr = dataUrl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  const saveSignature = async () => {
    try {
      let FileModel = new Files();
      if (sigCanvas.current) {
        const dataURL = sigCanvas.current.toDataURL();
        /* const dataURL2 = sigCanvasDoctor.current.toDataURL(); */
        let blob = dataURLtoBlob(dataURL);
        /* let blob2 = dataURLtoBlob(dataURL2); */
        blob = new File([blob], 'signature.png');
        /* blob2 = new File([blob2], 'signature_doctor.png'); */
        let result = await FileModel.uploadFile(blob);
        /* let result2 = await FileModel.uploadFile(blob2); */
        if (!result.location) {
          swal.fire({
            title: 'Error',
            text: 'Unable to upload signature, please try again later',
            icon: 'error',
            confirmButtonText: 'Go back',
            customClass: {
              container: 'swal-z'
            }
          });
          return;
        }
        let obj = {
          appointment_user_id: id,
          patient_id: selectedPatient.value,
          document_type: documentType.value,
          description: description,        
          signee_name: signeeName,
          signee_role: signeeRole,
          signature_url: result.location,
          doctor_id: parseInt(ID),
          doctor_signature_url: null
        };
        let appointmentModel = new Appointment();
        let newConsent = await appointmentModel.createAppointmentUserConsent(obj)
        //let updateResult = await appointmentModel.editAppointment(data.id, obj);
        console.log("cek submit", obj)
        if (newConsent) {
          swal
            .fire({
              title: 'success',
              text: 'successfully saving data',
              icon: 'success',
              confirmButtonText: 'Go back',
              customClass: {
                container: 'swal-z'
              }
            })
            .then(e => {
              window.location.reload();
            });
          setShowSignature(false);
        }
      }
    } catch (e) {
      swal.fire({
        title: 'Error',
        text: 'Something wrong, please try again later',
        icon: 'error',
        confirmButtonText: 'Go back',
        customClass: {
          container: 'swal-z'
        }
      });
      return;

      setShowSignature(false);
    }
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
    sigCanvasDoctor.current.clear();
    setSigneeName('');
    setSigneeRole('');
    setSelectedPatient(null);
    setDescription('');
  };

  useEffect(() => {
    initialize();
  }, []);

  const columns = [
    {
      dataField: 'created_at',
      text: 'Created Date',
      style: {
        width: '90px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && format(parseISO(cell), 'dd MMMM yyyy');
      }
    },
    {
      dataField: 'document_type',
      text: 'Type',
      style: {
        width: '300px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && <p style={{ whiteSpace: 'pre-line' }}>{cell}</p>;
      }
    },
    {
      dataField: 'description',
      text: 'Description',
      style: {
        width: '300px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && <p style={{ whiteSpace: 'pre-line' }}>{cell}</p>;
      }
    },
    {
      dataField: 'patient_name',
      text: 'Patient',
      style: {
        width: '300px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && <p style={{ whiteSpace: 'pre-line' }}>{cell}</p>;
      }
    },
    {
      dataField: 'user_name',
      text: 'Doctor',
      style: {
        width: '300px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && <p style={{ whiteSpace: 'pre-line' }}>{cell}</p>;
      }
    },
    {
      dataField: 'signee_name',
      text: 'Signee',
      style: {
        width: '300px'
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return cell && <p style={{ whiteSpace: 'pre-line' }}>{cell}</p>;
      }
    }
  ];

  return (
    <>
      <Dialog aria-labelledby="customized-dialog-title" open={showSignature}>
        <DialogTitle id="customized-dialog-title" onClose={handleCloseSignature}>
          Consent Form
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <label>Jenis Konsen</label>
            <Select  
              options={docuType}
              value={documentType}
              onChange={value => {
                console.log('isi', value)
                setDocumentType(value);
              }}
              styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 9999 })
              }}
            />

            <br />

            <p style={{whiteSpace : "pre-line"}}>
              {consentText[documentType.value]}
            </p>

            <label>Pasien</label>
            <Select  
              options={patientList}
              value={selectedPatient}
              onChange={value => {
                console.log('isi', value)
                setSelectedPatient(value);
              }}
              styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 9999 })
              }}
            />       

            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <label>Keterangan Tambahan</label>
              <TextField
                // id="name"
                value={description}
                onChange={e => setDescription(e.target.value)}
                label="Keterangan Tambahan"
                //input={<OutlinedInput label="Tag" />}
                // helperText={touched.name ? errors.name : ''}
                // error={touched.name && errors.name ? true : false}
              />
            </div>

            <label>TTD Pembawa</label>
            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              backgroundColor="#eee"
              canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
            />
            
            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex' }}>
              <div style={{width: '50%'}}>
                <TextField
                  // id="name"
                  value={signeeName}
                  onChange={e => setSigneeName(e.target.value)}
                  label="Nama Tertandatangan"
                  //input={<OutlinedInput label="Tag" />}
                  // helperText={touched.name ? errors.name : ''}
                  // error={touched.name && errors.name ? true : false}
                  style={{width: '80%'}}
                />
              </div>
              
              <div style={{width: '50%'}}>
                <TextField
                  // id="name"
                  value={signeeRole}
                  onChange={e => setSigneeRole(e.target.value)}
                  label="Peran Tertandatangan"
                  //input={<OutlinedInput label="Tag" />}
                  // helperText={touched.name ? errors.name : ''}
                  // error={touched.name && errors.name ? true : false}
                  style={{width: '80%'}}
                />
              </div>
              
            </div>
            {/* <SignatureCanvas
              ref={sigCanvasDoctor}
              penColor="black"
              backgroundColor="#eee"
              canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
            /> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={saveSignature} color="primary">
            Save changes
          </Button>
          <Button onClick={clearSignature} color="primary">
            Reset
          </Button>
          <Button
            onClick={e => {
              setShowSignature(false);
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {showSigg == true && <DoctorSignConsent data={selectedData} showSig={showSigg} setShowSig={setShowSigg} />}
      

      <Card>
        <CardHeader
          title="Form List"
          toolbar={
            <Grid item className="my-6">
              <Button color="primary" variant="contained" onClick={() => setShowSignature(true)}>
                New Form
              </Button>
            </Grid>
          }
        />
        <CardBody>
          <DataTable
            data={consentList}
            loading={false}
            totalDataCount={consentList.length}
            columns={columns}
            noEditAction
            renderCustomActions={(row, data) => {
              console.log('cek isi', data)
                if(data.doctor_signature_url == null) {
                  return (
                    <Button onClick={() => {
                      setSelectedData(data)
                      setShowSigg(true)
                   }} color="primary">Sign</Button>
                  );
                } else {
                  return (
                    <Button onClick={() => {
                      setSelectedData(data)
                      setShowSigg(true)
                   }} color="primary">View</Button>
                  );
                }
                
            }}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ConsentList;
